import cloudwatchArguments from '$src/constants/cloudwatch';
import StackTrace from 'stacktrace-js';
import getEnvironment from '$src/utils/enviroment';

/* global cwr */
/* eslint-disable */
function cloudwatch(n, i, v, r, s, c, x, z) {
  x = window.AwsRumClient = { q: [], n: n, i: i, v: v, r: r, c: c };
  window[n] = function (c, p) {
    x.q.push({ c: c, p: p });
  };
  z = document.createElement('script');
  z.async = true;
  z.src = s;

  const head = document.getElementsByTagName('head')[0];
  head.insertBefore(z, head.firstChild);
}
/* eslint-enable */

export default function initialize(userId, csrfToken) {
  const args = cloudwatchArguments[getEnvironment()];
  args[5].endpoint = `${origin}/api/logs/${userId}`;
  args[5].csrfToken = csrfToken;

  cloudwatch(...args);
}

export function sendCloudwatchRUMError(message, error, isUnhandled = false) {
  StackTrace.fromError(error).then((err) => {
    if (error instanceof Error) {
      let eventType;

      if (error.isAxiosError) {
        eventType = 'http_handled_error_event';
      }
      else {
        eventType = isUnhandled ? 'js_unhandled_error_event' : 'js_handled_error_event';
      }
      
      cwr?.('recordEvent', {
        type: eventType,
        data: {
          message,
          errorMessage: error.message,
          stack: error.stack,
          rawError: error,
          ...(error.isAxiosError && {
            'X-Amzn-Trace-Id': error.config?.headers['X-Amzn-Trace-Id'],
            'X-Amzn-RequestId': error.config?.headers['X-Amzn-RequestId'],
            response: error.request?.responseText,
            code: error.response?.status,
          }),
          ...err,
        },
      });
    }
  });
}

export function sendApplicationLoaded() {
  cwr?.('recordEvent', { type: 'application_load', data: { appVersion: process.env.VERSION } });
}
